<template>
  <i :class="iconclass" :style="style" />
</template>

<script>
export default {
  name: 'IconPart',
  props: {
    data: Object,
  },
  computed: {
    iconclass() {
      let { text } = this.data
      // 客户端增加了rf前缀 后续沟通如何统一 暂时先替换前缀
      text = text.replace(/^rf_icon(_|-)/, 'icon-')
      return text
    },
    style() {
      const { color, size } = this.data;
      return {
        color: color,
        size: size + 'px',
        'vertical-align': 'middle'
      };
    },
  },
};
</script>
